import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { SubscribableOrNullableValue } from 'knockout';
import './wcsSpinner.html';
import './wcsSpinner.scss';

export interface WCSSpinnerVMConfig {
    center: SubscribableOrNullableValue<boolean>
    small: SubscribableOrNullableValue<boolean>
    tiny: SubscribableOrNullableValue<boolean>
    visible: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class WCSSpinnerVM {
    imageURL = require('images/qualzy-spinner.gif').default;

    constructor(
        @inject(wccModules.componentConfig) config: WCSSpinnerVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const isVisible = ko.flattenComputed(config.visible, true);
        const isSmall = ko.flattenComputed(config.small, false);
        const isTiny = ko.flattenComputed(config.tiny, false);
        const isCentered = ko.flattenComputed(config.center, false);

        ko.applyBindingsToNode(info.element, {
            'visible': isVisible,

            'css': {
                'wcs-spinner': true,
                'wcs-spinner--small': ko.pureComputed(() => isSmall() && !isTiny()),
                'wcs-spinner--tiny': isTiny,
                'wcs-spinner--centered': isCentered
            }
        });
    }
}